module.exports = __webpack_public_path__ + "img/form-6.87d9d93.jpg";